export const getAllowedRoutes = (data = []) => {
  const routes = [];

  data.forEach((module) => {
    if (module?.module_url) {
      routes.push(module.module_url.toLowerCase());
    }

    module?.services?.forEach((service) => {
      if (service?.service_url) {
        routes.push(service.service_url.toLowerCase());
      }
    });
  });

  return routes;
};